import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getMetaVerifications } from '@seek/seek-jobs-seo';
import Dashboard from 'Dashboard/Dashboard';
import SARABanner from 'SARABanner/SARABanner';
import ContentSlider from 'ContentSlider/ContentSlider';
import QuickSearch from 'QuickSearch/QuickSearch';
import Helmet from 'react-helmet';

@connect(({ location }) => ({
  locale: location.locale
}))
export default class HomePage extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  render() {
    const { locale } = this.props;
    const { meta, link } = getMetaVerifications(locale);
    return (
      <div>
        <Helmet
          meta={meta}
          link={link}
        />
        <Dashboard />
        <ContentSlider trigger="dashboard">
          <SARABanner {...{ locale }} />
          <QuickSearch />
        </ContentSlider>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/HomePage.js
 **/